import { Avatar, Link } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Bank } from '@/api/dictionary';
import { ReactComponent as LinkIcon } from '@/assets/icons/link.svg';
import { Space, SubTitle } from '@/components';

type BankViewProps = { value: Bank };

export const BankView: React.FC<BankViewProps> = ({ value: { name, steps, detailsLink, icon } }: BankViewProps) => (
  <Space direction="vertical" size={2.5} style={{ flexShrink: 0 }}>
    <Space style={{ alignItems: 'center' }} size={1}>
      {icon && <Avatar src={icon} alt={name} />}
      <SubTitle>{name}</SubTitle>
    </Space>
    {steps.length > 0 && (
      <Space direction="vertical" size={2} style={{ overflow: 'auto', flexShrink: 0 }}>
        {steps.map((text, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Space key={index} wrapItems>
            {`${index + 1}.`}
            {text}
          </Space>
        ))}
      </Space>
    )}
    {detailsLink && (
      <Link href={`${detailsLink}`} target="_blank">
        <Space>
          <FormattedMessage id="invoice.components.bank.link" tagName="span" />
          <LinkIcon style={{ verticalAlign: 'sub' }} />
        </Space>
      </Link>
    )}
  </Space>
);

export default BankView;
